import React, { useEffect, memo } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Button from 'components/CommonUI/Button/Button'
import Title from './Title'

import {
  getRestorePasswordEmailString,
  setRestorePasswordEmailString,
  restorePassword,
  getErrorRestoreTypeSelector,
} from 'redux/reducers/profile'
import { useShallowEqualSelector } from 'custom-hooks'

const RecoveryPasswordSentEmail = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const restorePassEmailString = useShallowEqualSelector(
    getRestorePasswordEmailString
  )
  const errorType = useShallowEqualSelector(getErrorRestoreTypeSelector)

  if (!restorePassEmailString) {
    history.push('/')
  }

  const handleClickResend = () => {
    if (history?.location?.state?.userEmail)
      dispatch(restorePassword(history.location.state.userEmail))
  }

  useEffect(() => {
    if (errorType) {
      history.push('/auth/error-restore-password')
    }
  }, [errorType, history])

  useEffect(() => {
    return () => {
      dispatch(setRestorePasswordEmailString(''))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Title content="Check your inbox" className="account_recovery_title" />
      <Title
        content={`Reset password link has been sent to ${restorePassEmailString}`}
        type="subtitle"
        className="restore_password_sent_email_subtitle"
      />
      <span className="resend_link">
        Didn’t receive the link?{' '}
        <Button
          variant="text"
          fs={16}
          onClick={handleClickResend}
          className="resend_link_button"
        >
          Resend the link
        </Button>
      </span>
    </>
  )
}

export default memo(RecoveryPasswordSentEmail)
